import { Input } from 'antd'

const loginFields = [
  {
    key: 1,
    label: 'Email',
    name: 'email',
    rules: [
      { required: true, message: 'Please input your email!' },
      {
        type: 'email',
        message: 'The input is not valid E-mail!',
      },
    ],
    children: <Input />,
  },
  {
    key: 2,
    label: 'Password',
    name: 'password',
    rules: [{ required: true, message: 'Please input your password!' }],
    children: <Input.Password />,
  },
]

export default loginFields
